import {Component, inject, OnInit} from '@angular/core';
import {SlideTogglePadraoComponent} from "../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component";
import {ActiveDirectoryModel} from '../../shared/model/parametros/activeDirectory-model';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {GrupoAdService} from '../../shared/service/grupo-ad.service';
import {MsgService} from '../../shared/service/msg.service';
import {GrupoAdModel} from '../../shared/model/grupo/grupoAd-model';

@Component({
  selector: 'app-card-ad',
  standalone: true,
  imports: [
    SlideTogglePadraoComponent,
    FormFieldComponent,
    ButtonPadraoComponent
  ],
  templateUrl: './card-ad.component.html',
  styleUrl: './card-ad.component.css'
})
export class CardAdComponent implements OnInit {

  activeDirectory: ActiveDirectoryModel = new ActiveDirectoryModel();

  erroConexao = false;
  carregando = true;


  private readonly grupoAdService = inject(GrupoAdService);
  private readonly msgService = inject(MsgService);


  ngOnInit() {
    this.buscarConexaoAdPorGrupo();
  }


  buscarConexaoAdPorGrupo(){
    this.grupoAdService.buscarConexaoAdPorGrupo().subscribe({
      next: res => {
        this.activeDirectory = res;
        this.activeDirectory.dominio = res.ldapDomain;
        this.activeDirectory.ldapManagerFilter = res.ldapSearchFilter;
        this.activeDirectory.ldapManagerBase = res.ldapSearchBase;
        this.activeDirectory.ativo = res.ldapEnabled;
        this.carregando = false;
      },
      error: () => {
        this.carregando = false;
        this.msgService.msgErro('Erro ao buscar a configuração do Active Directory');
      }
    });
  }

  testarConexao(){
    if(this.fazerValidacaoCamposPreenchidos()){
      const grupoAd = new GrupoAdModel(this.activeDirectory);
      this.grupoAdService.verificarConexaoAd(grupoAd).subscribe({
        next: (result) => {
          if(result){
            this.erroConexao = false;
            this.msgService.msgSucesso('Conexão realizada com sucesso!');
          }
          else{
            this.erroConexao = true;
            this.msgService.msgAdvertencia('Não foi possível realizar a conexão!');
          }
        },
        error: () => {
          this.erroConexao = true;
          this.msgService.msgErro('Não foi possível realizar a conexão!')
        }
      });
    }
  }

  salvar(){
    const grupoAd = new GrupoAdModel(this.activeDirectory);
    if(this.fazerValidacaoCamposPreenchidos()){
      this.grupoAdService.salvarConexaoAd(grupoAd).subscribe({
        next: res => {
          if(res){
            this.erroConexao = false;
            this.msgService.msgSucesso('Grupo AD salvo com sucesso');
          }
          else{
            this.erroConexao = true;
            this.msgService.msgAdvertencia('Sem conexão com as credenciais informadas');
          }
        },
        error: () => {
          this.msgService.msgErro('Ocorreu um erro ao tentar salvar o Grupo AD');
        }
      });
    }
  }

  fazerValidacaoCamposPreenchidos(): boolean {
    if(!this.activeDirectory.nome || this.activeDirectory.nome === ''){
      this.msgService.msgAdvertencia('Preencha o nome');
      return false;
    }
    if(!this.activeDirectory.dominio || this.activeDirectory.dominio === ''){
      this.msgService.msgAdvertencia('Preencha o domínio');
      return false;
    }
    if(!this.activeDirectory.ldapUrl || this.activeDirectory.ldapUrl === ''){
      this.msgService.msgAdvertencia('Preencha a Ldap Url');
      return false;
    }
    if(!this.activeDirectory.ldapManagerFilter || this.activeDirectory.ldapManagerFilter === ''){
      this.msgService.msgAdvertencia('Preencha a Ldap Manager Filter');
      return false;
    }
    if(!this.activeDirectory.ldapManagerBase || this.activeDirectory.ldapManagerBase === ''){
      this.msgService.msgAdvertencia('Preencha a Ldap Manager Base');
      return false;
    }
    if(!this.activeDirectory.ldapManagerDn || this.activeDirectory.ldapManagerDn === ''){
      this.msgService.msgAdvertencia('Preencha a Ldap Manager DN');
      return false;
    }
    if(!this.activeDirectory.ldapManagerPassword || this.activeDirectory.ldapManagerPassword === ''){
      this.msgService.msgAdvertencia('Preencha a senha do Ldap');
      return false;
    }
    return true;
  }

}
